import Vue from 'vue';
import Toasted from 'vue-toasted';

Vue.use(Toasted, {
  position: 'top-right',
  containerClass: 'toast-container',
  className: 'toast-potpourri',
  duration: 5000,
});



// WEBPACK FOOTER //
// ./src/plugins/vue-toasted.js